import { render, staticRenderFns } from "./Myaccount.vue?vue&type=template&id=4b6b2cd2&scoped=true&"
import script from "./Myaccount.vue?vue&type=script&lang=js&"
export * from "./Myaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6b2cd2",
  null
  
)

export default component.exports